var _templateObject = _taggedTemplateLiteralLoose(["\n  color: rgba(0, 0, 0, 0.3);\n  padding-right: 1rem;\n"], ["\n  color: rgba(0, 0, 0, 0.3);\n  padding-right: 1rem;\n"]),
    _templateObject2 = _taggedTemplateLiteralLoose(["\n  font-weight: 300;\n  font-size: 0.7rem;\n"], ["\n  font-weight: 300;\n  font-size: 0.7rem;\n"]),
    _templateObject3 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 1px;\n  bottom: 1px;\n  left: 1px;\n  right: 1px;\n"], ["\n  position: absolute;\n  top: 1px;\n  bottom: 1px;\n  left: 1px;\n  right: 1px;\n"]),
    _templateObject4 = _taggedTemplateLiteralLoose(["\n  visibility: hidden;\n"], ["\n  visibility: hidden;\n"]);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

/** @jsx jsx */
import React, { Fragment, forwardRef } from "react";
import { isArray, times } from "lodash-es";
import { observer } from "mobx-react";
import { css, jsx } from "@emotion/core";
import { IconButton, Box, Slider, SliderTrack, SliderFilledTrack, SliderThumb } from "@chakra-ui/core";

var FIELD_PLACEHOLDER = "Enter value...";

var fieldPlaceholderStyles = css(_templateObject);

var fieldArrayCountStyles = css(_templateObject2);

var sliderFieldWrapperStyles = css(_templateObject3);

var spacerComponentStyles = css(_templateObject4);

export var Spacer = function Spacer(_ref) {
  var _ref$length = _ref.length,
      length = _ref$length === undefined ? 10 : _ref$length,
      _ref$hiddenChar = _ref.hiddenChar,
      hiddenChar = _ref$hiddenChar === undefined ? "-" : _ref$hiddenChar;
  return jsx(
    "span",
    { css: spacerComponentStyles },
    times(length).map(function () {
      return hiddenChar;
    }).join("")
  );
};

var FieldValueDisplay = forwardRef(function (_ref2, ref) {
  var node = _ref2.node;
  var isSliderField = node.isSliderField,
      fieldMetaData = node.fieldMetaData,
      formatted = node.formatted;


  var content = formatted;

  if (formatted === "") {
    content = jsx(
      "span",
      { css: fieldPlaceholderStyles },
      FIELD_PLACEHOLDER
    );
  }

  if (isSliderField) {
    content = jsx(
      Fragment,
      null,
      jsx(Spacer, { length: 22 }),
      jsx(
        Box,
        { display: "flex", pl: 1, css: sliderFieldWrapperStyles },
        jsx(
          Slider,
          {
            value: node.value,
            min: fieldMetaData.min,
            max: fieldMetaData.max,
            step: fieldMetaData.step,
            onChange: node.setValue,
            size: "sm"
          },
          jsx(SliderTrack, null),
          jsx(SliderFilledTrack, null),
          jsx(
            SliderThumb,
            { w: "auto", p: 1, fontSize: "0.8rem" },
            node.value
          )
        ),
        jsx(IconButton, {
          variant: "ghost",
          size: "sm",
          icon: "edit",
          height: "100%",
          minWidth: "auto",
          p: "0 5px",
          fontSize: "0.6rem",
          onClick: function onClick() {
            return node.toggleEditing();
          }
        })
      )
    );
  }

  if (isArray(formatted)) {
    content = jsx(
      Fragment,
      null,
      "[",
      [formatted[0], formatted[formatted.length - 1]].filter(function (el) {
        return !!el;
      }).join(formatted.length > 2 ? ", ... , " : ", "),
      "] ",
      jsx(
        "span",
        { css: fieldArrayCountStyles },
        "(x",
        formatted.length,
        ")"
      )
    );
  }

  return jsx(
    "span",
    { ref: ref },
    content
  );
});

export default observer(FieldValueDisplay);